/**
 * Map of legacy tenant slug → friendly display name.
 *
 * Mirrors the labels rendered in `layout/TenantSwitcher.tsx` so Master
 * Mode lists show the same human-readable tenant names that the tenant
 * selector uses. Keep in sync with the `MenuItem` labels in the
 * switcher.
 */
const TENANT_DISPLAY_NAMES: Record<string, string> = {
    kolula: 'kolula SUP',
    dhu: 'Dhu',
    vonovia_v2: 'Vonovia',
    neuland: 'Neuland',
    seezeit: 'Seezeit',
    'strandbad-pertisau': 'Strandbad Pertisau',
    'badesee-petershagen': 'Badesee Petershagen',
    demo: 'Demo',
    'kolula-key': 'kolula KEY',
    segmenta_v2: 'Segmenta',
};

/**
 * Runtime-registered names for tenants that aren't in the hardcoded
 * legacy map — the onboarded operational-DB tenants, whose organization
 * names only become known once `GET /admin/tenants` responds (see
 * `useAccessibleTenants`). Registration is an idempotent cache write;
 * the components using these names re-render anyway when the tenant
 * list itself changes.
 */
const registeredNames: Record<string, string> = {};

export const registerTenantDisplayNames = (names: Record<string, string>): void => {
    Object.assign(registeredNames, names);
};

/**
 * Returns the friendly display name for a tenant slug, falling back to
 * the slug itself if unknown.
 */
export const getTenantDisplayName = (slug: string): string =>
    TENANT_DISPLAY_NAMES[slug] ?? registeredNames[slug] ?? slug;
